import get from 'lodash/get'
import {
  CFEntryWithHeroImageAndRetailer,
  CFEntryImageSet,
} from '../../../types/contentful'
import { ImageTypes, Image } from '../../../types/images'

const imageTypeToColorField = (
  imageType: ImageTypes
):
  | 'masterSupportingColour'
  | 'standardSupportingColour'
  | 'squareSupportingColour' => {
  switch (imageType) {
    case ImageTypes.Master:
      return 'masterSupportingColour'
    case ImageTypes.Standard:
      return 'standardSupportingColour'
    case ImageTypes.Square:
      return 'squareSupportingColour'
    default:
      return 'masterSupportingColour'
  }
}

const getEntryImageFromImageSet = (
  imageSet: CFEntryImageSet,
  imageType: ImageTypes
): Image => {
  const image = imageSet[imageType]
  const color = imageSet[imageTypeToColorField(imageType)]

  if (image) {
    return {
      alt: imageSet.description || image.description,
      src: image.url,
      imageType,
      supportingColor: color,
    }
  } else {
    return {
      alt: '',
      src: '',
      imageType: null,
    }
  }
}

const getImageFromEntry = (
  entry: CFEntryWithHeroImageAndRetailer,
  imageType: ImageTypes,
  fallbackImageType = ImageTypes.Master
): Image => {
  if (get(entry, `heroImageSet.${imageType}.url`)) {
    return getEntryImageFromImageSet(entry.heroImageSet, imageType)
  } else if (get(entry, `heroImageSet.${fallbackImageType}.url`)) {
    return getEntryImageFromImageSet(entry.heroImageSet, fallbackImageType)
  }

  if (entry?.__typename === 'Store' && entry?.retailer) {
    return getImageFromEntry(entry.retailer, imageType, fallbackImageType)
  }

  return {
    alt: null,
    src: null,
    imageType: null,
  }
}

export const MASTER = ImageTypes.Master
export const STANDARD = ImageTypes.Standard
export const SQUARE = ImageTypes.Square

export default getImageFromEntry
